/**
 * @generated SignedSource<<947357306e5b6ee1efcf35249decc45d>>
 * @relayHash a642a2a0dd255f317a6f88ac10e76918
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID a642a2a0dd255f317a6f88ac10e76918

import { ConcreteRequest } from 'relay-runtime';
export type setTodoDoneInput = {
  clientMutationId?: string | null | undefined;
  date: string;
  todoId: string;
};
export type TodoMutations_SetTodoDoneMutation$variables = {
  input: setTodoDoneInput;
};
export type TodoMutations_SetTodoDoneMutation$data = {
  readonly setTodoDone: {
    readonly todo: {
      readonly done: boolean;
      readonly doneTs: string | null | undefined;
    };
  } | null | undefined;
};
export type TodoMutations_SetTodoDoneMutation = {
  response: TodoMutations_SetTodoDoneMutation$data;
  variables: TodoMutations_SetTodoDoneMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "done",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "doneTs",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "TodoMutations_SetTodoDoneMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "setTodoDonePayload",
        "kind": "LinkedField",
        "name": "setTodoDone",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Todo",
            "kind": "LinkedField",
            "name": "todo",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "TodoMutations_SetTodoDoneMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "setTodoDonePayload",
        "kind": "LinkedField",
        "name": "setTodoDone",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Todo",
            "kind": "LinkedField",
            "name": "todo",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "a642a2a0dd255f317a6f88ac10e76918",
    "metadata": {},
    "name": "TodoMutations_SetTodoDoneMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "45f62e54b85905cc0bb330be30b174e5";

export default node;
